module.exports = __webpack_public_path__ + "img/hardware_pic.11cb5d8b.png";